// Configurations are injected at runtime via a global variable `ENV`
// If window.ENV is already set by K8s deployment, otherwise use defaults
const config =
  window.ENV ||
  (window.ENV = {
    intermediary_endpoint: "https://api.staging-bycsmessenger.dev/",
    intermediary_url: "https://api.staging-bycsmessenger.dev/",
    keycloak: {
      discovery_url:
        "https://auth.staging-bycsmessenger.dev/realms/bycs-messenger",
      client_id: "intermediary-adminpanel",
      scope: "profile openid",
    },
    sentry: {
      dsn: "",
      env: "",
    },
  });

export default config;
